/* wbpk-export-def-class export default  */ class PageHelper {
  /**
   * Returns current section file name (someSection.html)
   * @returns {string}
   */
  static getCurrentPage() {
    const splitUrl = window.location.pathname.split('/');
    return splitUrl.pop();
  }
}
